import PropTypes from 'prop-types';
import {Translate, I18n} from 'react-redux-i18n';
import {useHistory} from 'react-router-dom';

import {ThreeDotsMenu, MenuCommand} from 'front-onceforall-core';

import config from '../../../../../config';

function Menu(props) {
  const history = useHistory();

  const handleGoToCallback = to => () => {
    history.push(`${props.baseUrl}/${to}`);
  };

  return (
    <ThreeDotsMenu
      data-id="project-actions"
      big
    >
      <MenuCommand
        data-id="project-actions-chart"
        label={<Translate value="project.goToChart"/>}
        icon="organisation"
        onClick={handleGoToCallback('chart')}
      />
      {config.featureFlags.invalidDocuments &&
          <MenuCommand
            data-id="project-actions-invalid-documents"
            label={<Translate value="project.showInvalidDocumentsPage"/>}
            icon="document"
            onClick={handleGoToCallback('invalid-organisation-documents')}
          />
      }
      {props.showMenu &&
          <MenuCommand
            data-id="project-actions-edit-details"
            label={<Translate value="project.edit.editProjectDescription"/>}
            icon="edit"
            onClick={props.onOpenEditProjectPanel}
            disabled={props.isClosed}
            disabledMessage={I18n.t('project.actionProjectClosed')}
          />
      }
      <MenuCommand
        data-id="project-actions-edit-required-documents"
        label={props.showMenu ?
          <Translate value="project.edit.editRequiredDocuments"/> :
          <Translate value="project.edit.seeRequiredDocuments"/>
        }
        icon="document-page"
        onClick={handleGoToCallback('required-documents')}
        disabled={props.isClosed}
        disabledMessage={I18n.t('project.actionProjectClosed')}
      />
      {!props.isClosed && props.showMenu &&
          <MenuCommand
            data-id="project-actions-close-project"
            label={<Translate value="project.close"/>}
            icon="cross"
            onClick={props.openConfirmCloseProjectModal}
          />
      }
      <MenuCommand
        data-id="project-actions-grant-access"
        label={<Translate value="project.grantAccess.button"/>}
        icon="user-plus"
        onClick={handleGoToCallback('user-access')}
      />
      <MenuCommand
        data-id="project-actions-export-dossier"
        label={<Translate value="project.exportDossier"/>}
        icon="folder-download"
        onClick={props.onDownloadProjectStatus}
      />
      <MenuCommand
        data-id="project-actions-export-project-overview"
        label={<Translate value="project.exportQuitus"/>}
        icon="download"
        onClick={props.onDownloadProjectOverviewReport}
      />
    </ThreeDotsMenu>
  );
}

Menu.propTypes = {
  showMenu: PropTypes.bool.isRequired,
  isClosed: PropTypes.bool.isRequired,
  baseUrl: PropTypes.string.isRequired,
  onOpenEditProjectPanel: PropTypes.func.isRequired,
  openConfirmCloseProjectModal: PropTypes.func.isRequired,
  onDownloadProjectStatus: PropTypes.func.isRequired,
  onDownloadProjectOverviewReport: PropTypes.func.isRequired
};

export default Menu;
